// extracted by mini-css-extract-plugin
export var active = "YOS9ZUq6XfRvlWfFRJL_";
export var customTitle2 = "Z10nmkJ0UINlJH5JkSGh";
export var destructive = "InPiZeFXlN24kc3ronMP";
export var focusVisible = "RAlVsriX7dAIm887U96w";
export var fullWidth = "cCSbV5W3YjNtPmqpxJMw";
export var ghost = "jXLdLqhXveB81GQreYNL";
export var icon = "b4WhMbaC0_0iHtdB53i3";
export var iconPlaceholder = "TdKrhCNPrTjfuGezWLhr";
export var large = "yWfNpNV4i1tMbMgyhJNg";
export var loading = "vXjvvIIyZZj2cujicdXp";
export var medium = "OTDn4mZpUOhyiVADLqTh";
export var primary = "QH6GtZpC8Q2YeC6TmOJ6";
export var root = "su27mLyoYzGQ3FBRQSSJ";
export var secondary1 = "_z_XTgctg56ohUryq4yI";
export var secondary2 = "yoU4tqwLmD6jKZvGviAQ";
export var secondary3 = "pxG1E9Q3luUR0X5n4jDd";
export var small = "Bbb46TkzACxc9f2wm5Bf";
export var spinner = "j_mw5IAI7U8SV063Zu2l";
export var tertiary = "JUEOHl8Mp6tjxVXLawDm";
export var tertiaryDestructive = "P7xCinEcXkQRuuuIv9S_";
export var text = "J0hG3_c6afx448Dvq3lN";
export var xLarge = "h4JP43fRVLnUAD2YAEKF";